"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.extractEvents = extractEvents;
exports.eventExists = eventExists;
function extractEvents(receipt, contractInterfaces, eventNames) {
    const res = [];
    receipt.logs.map((log) => {
        for (const topic of log.topics) {
            for (const contractInterface of contractInterfaces) {
                if (!eventExists(topic, contractInterface)) {
                    continue;
                }
                const event = contractInterface.parseLog(log);
                if (eventNames && eventNames.length > 0 && !eventNames.includes(event.name)) {
                    continue;
                }
                event.txHash = receipt.transactionHash;
                event.address = log.address;
                event.blockNumber = receipt.blockNumber;
                event.logIndex = log.logIndex;
                res.push(event);
            }
        }
    });
    return res;
}
function eventExists(nameOrSignatureOrTopic, contractInterface) {
    const topichash = nameOrSignatureOrTopic.toLowerCase();
    for (const name in contractInterface.events) {
        if (topichash === contractInterface.getEventTopic(name)) {
            return true;
        }
    }
    return false;
}
